import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { findClients } from 'api';

class ClientSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value : undefined
    }
    this.getOptions = this.getOptions.bind(this);
  }
  getOptions(input) {
    // if(this.props.options.length > 0) {
    //   return new Promise((res,rej) => res(this.props.options));
    // }
    return findClients(input)
        .then(clients => ({
          options : clients.map(
            client => ({
              label : client.name,
              value : client._id
            })
          )
        }))
  }
  render() {
    return (
      <Select.Async
        placeholder={this.props.placeholder || 'Find a Client'}
        style={{zIndex : 99}}
        name="client-select"
        value={this.props.value || this.state.value}
        loadOptions={this.getOptions}
        onChange={this.props.onChange}
      />
    )
  }
}

ClientSelect.propTypes = {
  onChange : PropTypes.func.isRequired,
}

export default ClientSelect;



// WEBPACK FOOTER //
// ./src/browser/components/client/client-select.js